module.exports = __webpack_public_path__ + "media/assets/icons/ic-listed-a2f3c7f5bcf32941daa89a2d4758e8ff.svg";